import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";

import App from "./App";
import AuthProvider from "./store/auth";
import { ConfirmDialogProvider } from "./components/organisms/confirm-dialog/confirm-dialog-context-provider";
import { ApolloClientProvider } from "./graphql/apollo-client-provider";

import "./observability/instrument";
import "bootstrap/dist/css/bootstrap.css";

ReactDOM.createRoot(document.getElementById("root")!, {
	// Callback called when an error is thrown and not caught by an Error Boundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn("Uncaught error", error, errorInfo.componentStack);
	}),
	// Callback called when React catches an error in an Error Boundary.
	onCaughtError: Sentry.reactErrorHandler(),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler(),
}).render(
	<React.StrictMode>
		<AuthProvider>
			<ConfirmDialogProvider>
				<ApolloClientProvider>
					<Router>
						<App />
					</Router>
				</ApolloClientProvider>
			</ConfirmDialogProvider>
		</AuthProvider>
	</React.StrictMode>,
);
